/* src/app/shared/components/global-search/global-search.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  display: flex;
  align-items: center;
}
.nav__select {
  width: 10em;
  margin-right: 0.75em;
}
.nav__search,
.nav__search__dialog {
  padding: 0.7em;
  display: inline-block;
  border-radius: 5px;
}
.nav__search,
.nav__search__dialog {
  width: 30vw;
  min-width: 110px;
  max-width: 300px;
  max-height: 16px;
}
.nav__search:focus-visible,
.nav__search:not(:placeholder-shown),
.nav__search__dialog:focus-visible,
.nav__search__dialog:not(:placeholder-shown) {
  outline: 1px solid #006BB6;
  background: #E9EDEF;
  margin: 1px;
}
.nav__search {
  border: none !important;
  font-family:
    "Inter",
    Arial,
    sans-serif;
}
.nav__search::placeholder {
  color: black;
  font-weight: 600;
}
.nav__search__dialog {
  border: 1px solid #7C829E;
  padding-left: 2.25em;
}
.nav__search-icon {
  height: 1.3em;
  padding-right: 0.2em;
}
.global-search-dialog {
  max-height: 90vh !important;
  max-width: 75vw;
  color: #666666 !important;
  padding: 24px;
  margin: 0;
}
.global-search-dialog a:not(.highlight-color) {
  color: #666666 !important;
}
.global-search-dialog .cursor-pointer,
.global-search-dialog a,
.global-search-dialog button {
  cursor: pointer;
}
.global-search-dialog .align-bottom {
  vertical-align: bottom !important;
}
.global-search-dialog .highlight-color {
  color: #006BB6;
}
.global-search-dialog .pl-xxsmall {
  padding-left: 2px;
}
.global-search-dialog .pl-small {
  padding-left: 8px;
}
.global-search-dialog .pl-medium {
  padding-left: 16px;
}
.global-search-dialog .pr-medium {
  padding-right: 16px;
}
.global-search-dialog .hover-bg-color {
  background-color: #E9EDEF;
}
.global-search-dialog .search-presufix-wrapper {
  vertical-align: text-top;
  display: inline-block;
}
.global-search-dialog .search-presufix-wrapper .search-prefix-icon {
  position: absolute;
  padding: 0 0.7em;
}
.global-search-dialog .search-presufix-wrapper .close-sufix-icon {
  margin-left: -1.6em;
  cursor: pointer;
}
.global-search-dialog .search-presufix-wrapper .search-prefix-icon,
.global-search-dialog .search-presufix-wrapper .close-sufix-icon {
  color: #006BB6;
  height: 1.1em;
  width: 1.1em;
}
.global-search-dialog .border-wrapper {
  border-top: 1px solid #DFE0EB;
  margin: 1.1em -24px 1.1em -24px;
}
.global-search-dialog .recent-label {
  padding: 0.5em 0 1em 0;
}
.global-search-dialog .history-wrapper {
  margin: 0 -24px;
  display: flex;
}
.global-search-dialog .history-wrapper .mat-icon {
  color: black;
  margin-left: 1em;
}
.global-search-dialog .history-wrapper .close-item-small {
  width: 1.3em !important;
  height: 1.3em !important;
}
.global-search-dialog .history-wrapper .result-label {
  color: black;
}
.global-search-dialog .history-wrapper,
.global-search-dialog .results-wrapper {
  padding: 0.6em 0.3em;
}
.global-search-dialog .history-wrapper span,
.global-search-dialog .results-wrapper span {
  display: inline-block;
}
.global-search-dialog .history-wrapper .result-label,
.global-search-dialog .results-wrapper .result-label {
  align-self: center;
  vertical-align: middle;
}
.global-search-dialog .history-wrapper .delete-his-label,
.global-search-dialog .results-wrapper .delete-his-label {
  margin-left: auto;
}
.global-search-dialog .history-wrapper .mat-icon,
.global-search-dialog .results-wrapper .mat-icon {
  width: 1.5em;
  height: 1.5em;
  padding-right: 0.7em;
}
.global-search-dialog .history-wrapper .results-inner-wrapper,
.global-search-dialog .results-wrapper .results-inner-wrapper {
  margin: 0.7em 0 0.72em 2.2em;
  display: flex;
  align-items: center;
}
.global-search-dialog .history-wrapper .results-inner-wrapper:first-of-type,
.global-search-dialog .results-wrapper .results-inner-wrapper:first-of-type {
  padding-top: 0.35em;
}
.global-search-dialog .history-wrapper .results-inner-wrapper .no-button-style,
.global-search-dialog .results-wrapper .results-inner-wrapper .no-button-style {
  background: none;
  border: none;
  font-family: unset;
  font-weight: unset;
  font-size: 14px;
}
.global-search-dialog .history-wrapper .results-inner-wrapper .no-button-style:not(:disabled),
.global-search-dialog .results-wrapper .results-inner-wrapper .no-button-style:not(:disabled) {
  color: #006BB6;
}
.global-search-dialog .results-wrapper .mat-icon {
  vertical-align: top;
}
.global-search-dialog .show-more-wrapper {
  border-top: 1px solid #DFE0EB;
  padding: 24px 24px 0 24px;
  margin: 1.1em -24px 0 -24px;
  font-weight: bold;
}
.global-search-dialog .show-more-wrapper .mat-icon {
  float: right;
}
.global-search-dialog mat-spinner,
.global-search-dialog .mat-progress-spinner,
.global-search-dialog .mat-progress-spinner svg {
  margin: 0.7em auto;
}
.global-search-dialog .toggle-group {
  margin-top: 4px;
  margin-bottom: 17px;
}
.mg-rt {
  margin-right: 8px;
}
/*# sourceMappingURL=global-search.component.css.map */
